import React from 'react';
import { Container, Alert } from 'react-bootstrap';

const S9MyEmailTemplates = () => {
  return (
    <Container>
      <h1>E-Mail-Vorlagen</h1>
      <Alert variant="info">
        Dieser Bereich befindet sich noch im Aufbau. Hier können Sie bald Ihre E-Mail-Vorlagen anpassen und verwalten.
      </Alert>
    </Container>
  );
};

export default S9MyEmailTemplates;